import React, {FC} from "react"
import {Col, Grid, Row} from "react-bootstrap"

import {WellnessMediaType, WellnessMedia, MarketingProfile, UpdateMarketingProfileInput} from "@irati/types"

import {videoInProgress} from "@irati/wellness/utils"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import MediaDetails from "../components/MediaDetails"
import RelatedMediaList from "../components/RelatedMediaList"
import LiveVideoPlayer from "../components/LiveVideoPlayer"
import MediaContent from "../components/MediaContent"

interface Props extends InjectIntl {
  media: WellnessMedia
  marketingProfile: MarketingProfile
  handleClick: (marketingProfileInput: UpdateMarketingProfileInput) => void
}

const SingleMedia: FC<Props> = ({media, marketingProfile, handleClick}) => {
  const liveVideoInProgress = videoInProgress(media.liveVideoStartTime, media.liveVideoEndTime)
  let chatSource = ""

  if (media.src.includes("/embed")) {
    chatSource = media.src.replace("/embed/", "/chat/")
  }

  return (
    <Grid>
      {!liveVideoInProgress ? (
        <MediaContent
          media={media}
          marketingProfile={marketingProfile}
          handleClick={handleClick}
          liveVideoInProgress={liveVideoInProgress}
        />
      ) : (
        <>
          {chatSource ? (
            <>
              <Row>
                <Col md={8} sm={12}>
                  {media.type === WellnessMediaType.LiveVideo && (
                    <LiveVideoPlayer media={media} liveVideoInProgress={liveVideoInProgress} />
                  )}
                </Col>
                <Col md={4} sm={12} xs={12}>
                  <Flex marginTop={5} height="420px">
                    <iframe src={chatSource} title={media.title} width="100%" height="100%" frameBorder="0" />
                  </Flex>
                </Col>
              </Row>
              <Row>
                <Col md={8} sm={12}>
                  <MediaDetails media={media} liveVideoInProgress={liveVideoInProgress} />
                </Col>
                <Col md={4} sm={12} xs={12}>
                  <RelatedMediaList media={media} marginTop={4} />
                </Col>
              </Row>
            </>
          ) : (
            <MediaContent
              media={media}
              marketingProfile={marketingProfile}
              handleClick={handleClick}
              liveVideoInProgress={liveVideoInProgress}
            />
          )}
        </>
      )}
    </Grid>
  )
}

export default injectIntl(SingleMedia)
